/*
 * Copyright (C) 2021 Corsair M360, Inc - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import globalMixins from "@/mixins/globalMixins";

export default {
	name: 'fieldsMixins',
	
	mixins: [globalMixins],
	
	data() {
		return {
			fieldsAcl: {
				registry: {
					create: {},
					update: {}
				}
			}
		}
	},
	
	components: {},
	
	computed: {},
	
	methods: {
		
		registryUpdateAccess() {
			let route = '/environments/:env/registry';
			let method = 'patch';
			
			this.fieldsAcl.registry.update = {
				security: this.canAccessField({
					route: route,
					method: method,
					field: 'security'
				}),
			};
			return this.fieldsAcl.registry.update;
		}
		
	}
}
